export default {
    'title.invoice': 'Invoice',
    'title.estimate': 'Estimate',
    'title.tax_invoice': 'Tax Invoice',
    'title.simplified_tax_invoice': 'Simplified Tax Invoice',
    'title.credit_note': 'Credit note',
    'title.tax_credit_note': 'Tax Credit Note',
    'title.simplified_tax_credit_note': 'Simplified Tax Credit Note',
    'title.receipt': 'Receipt',
    'title.payment_receipt': 'Payment receipt',
    'title.refund_voucher': 'Refund voucher',
    'title.statement': 'Statement of account',
    'title.prefactura': 'Prefactura',
    'label.invoice_no': 'Invoice No.',
    'label.patient': 'Patient',
    'label.mrn': 'MRN',
    'label.date': 'Date',
    'label.payer': 'Payer',
    'label.self_pay': 'Self',
    'label.description': 'Description',
    'label.qty': 'Qty',
    'label.rate': 'Rate',
    'label.discount': 'Discount',
    'label.amount': 'Amount',
    'label.gross': 'Gross',
    'label.vat': 'VAT',
    'label.vat_rate': 'VAT %',
    'label.total': 'Total',
    'label.total_excl_vat': 'Total excl. VAT',
    'label.total_incl_vat': 'Total incl. VAT',
    'label.panel_share': '{term_panel_title} share',
    'label.patient_share': 'Patient share',
    'label.payments_received': 'Payments received',
    'label.balance_due': 'Balance due',
    'label.balance': 'Balance',
    'label.paid': 'Paid',
    'label.vat_number': 'VAT No.',
    'label.cr_number': 'CR No.',
    'label.trn': 'TRN',
    'label.company_number': 'Company No.',
    'label.ntn': 'NTN',
    'label.nit': 'NIT',
    'label.buyer': 'Buyer',
    'label.buyer_vat_number': 'Buyer VAT No.',
    'label.cashier': 'Cashier',
    'label.received_by': 'Received by',
    'label.thank_you': 'Thank you',
    'note.citizen_relief': 'VAT borne by the State (Saudi citizen)',
    'note.not_electronic_invoice': 'This document is not an electronic sales invoice.',
    'note.estimate': 'Not a tax invoice. Prices may change until the bill is issued.',
    'note.exempt': 'Exempt',
    'note.zero_rated': 'Zero-rated',
    'label.tax': 'Tax',
    'label.walk_in': 'Walk-in',
    'label.returns_and_credit_notes': 'Returns and credit notes',
    'label.refunded': 'Refunded',
    'label.paid_after_refunds': 'Paid after refunds',
    'label.credit_balance_due': 'Credit balance due to customer',
    'label.payments': 'Payments',
    'label.received': 'Received',
    'label.receipt': 'Receipt',
    'label.mode': 'Mode',
    'label.reference': 'Reference',
    'label.credit_notes': 'Credit notes',
    'label.number': 'Number',
    'label.reason': 'Reason',
    'label.refund': 'Refund',
    'label.taxable_amount': 'Taxable amount',
    'label.seller': 'Seller',
    'label.address': 'Address',
    'label.page_footer': 'Invoice {number} · {status} · generated {stamp}',
    'label.against_invoice': 'Against invoice',
    'label.customer': 'Customer',
    'label.credited': 'Credited',
    'label.vat_included': 'VAT included',
    'label.credit_total': 'Credit total',
    'label.issued_by': 'Issued by',
    'label.approved_by': 'Approved by',
    'label.opening_balance': 'Opening balance',
    'label.closing_balance': 'Closing balance',
    'label.charges': 'Charges',
    'label.credits': 'Credits',
    'label.period': 'Period',
    'label.document': 'Document',
    'label.total_billed': 'Total billed',
    'label.balance_owing': 'Balance owing',
    'label.advances_held': 'Advances held',
    'label.amount_due': 'Amount due',
    'label.credit_refundable': 'Credit / refundable',
    'label.billing_officer': 'Billing officer',
    'label.patient_attendant': 'Patient / attendant',
    'label.scope': 'Scope',
    'label.generated': 'Generated',
    'label.invoice': 'Invoice',
    'label.type': 'Type',
    'label.payments_and_refunds': 'Payments and refunds',
    'label.advances': 'Advances',
    'label.summary': 'Summary',
    'label.reductions': 'Credit notes, returns and refunded bills',
    'label.received_from': 'Received from',
    'label.paid_to': 'Paid to',
    'label.admission': 'Admission',
    'label.original_receipt': 'Original receipt',
    'label.paid_out_by': 'Paid out by',
    'label.shift': 'Shift',
    'label.no_shift': 'No shift',
    'label.amount_received': 'Amount received',
    'label.amount_paid_out': 'Amount paid out',
    'sig.od': 'once a day',
    'sig.bd': 'twice a day',
    'sig.tds': 'three times a day',
    'sig.qid': 'four times a day',
    'sig.hs': 'at night',
    'sig.sos': 'when needed',
    'sig.stat': 'straight away, one dose',
    'sig.for_days': '{days, plural, one {for # day} other {for # days}}',
    'title.dispensing_label': 'Dispensing label',
    'label.dispensed': 'Dispensed',
    'label.how_to_take': 'How to take',
    'title.payer_tax_invoice': 'Tax invoice',
    'title.payer_credit_note': 'Credit note',
    'label.insurer': 'Insurer',
    'label.claim': 'Claim',
    'label.amount_before_vat': 'Amount before VAT',
    'label.bills_covered': 'Bills covered',
    'label.bill': 'Bill',
    'label.insurer_share': 'Insurer share',
    'label.first_bills_only': 'Showing the first {count} bills.',
    'lab.title': 'Laboratory report',
    'lab.final': 'FINAL REPORT',
    'lab.preliminary': 'PRELIMINARY REPORT',
    'lab.amended': 'AMENDED REPORT',
    'lab.provisional': 'PROVISIONAL — not all results are verified',
    'lab.patient': 'Patient',
    'lab.order': 'Order',
    'lab.mrn': 'MRN',
    'lab.dob': 'Date of birth',
    'lab.age_sex': 'Age / Sex',
    'lab.ordered': 'Ordered',
    'lab.collected': 'Collected',
    'lab.received': 'Received',
    'lab.released': 'Released',
    'lab.printed': 'Printed',
    'lab.referred_by': 'Referred by',
    'lab.test': 'Test',
    'lab.result': 'Result',
    'lab.unit': 'Unit',
    'lab.reference': 'Reference',
    'lab.specimen': 'Specimen',
    'lab.status': 'Status',
    'lab.pending': 'Pending',
    'lab.preliminary_marker': 'Preliminary',
    'lab.performed_by': 'Performed by',
    'lab.reissued': 'Reissued — patient details corrected on',
    'lab.footer': 'Results relate only to the specimen received. Please correlate clinically.',
    'label.in_package': 'In package',
    'label.in_package_list_value': 'In package · list value {amount}',
    'label.package_sale': 'Package sold to the patient',
    'label.beyond_package': 'Beyond the package',
    'label.package_savings': 'Package savings',
};
//# sourceMappingURL=print.js.map